import { csrfHeader } from './api.js';

// The moderation area talks to /admin/api, not /panel/api, so it cannot go
// through app/api.js — which hard-codes the publisher prefix. One client here
// rather than a copy in each of the three admin views.

export async function adminRaw(method, path, payload) {
  return fetch(`/admin/api${path}`, {
    method,
    headers: {
      ...(payload ? { 'Content-Type': 'application/json' } : {}),
      ...csrfHeader(),
    },
    credentials: 'same-origin',
    body: payload ? JSON.stringify(payload) : undefined,
  });
}

// Swallows a failure into `[]`, which is what the read-only panels want: one
// panel that cannot load must not take the whole dashboard down with it. Use
// adminRaw where the reason for a refusal is the point.
export async function admin(method, path, payload) {
  const response = await adminRaw(method, path, method === 'GET' ? null : payload);
  if (response.status === 204) return null;
  return response.ok ? response.json() : [];
}
